import { render, staticRenderFns } from "./ctrlSynegyEffectgridView.vue?vue&type=template&id=e6a0bdca&"
import script from "./ctrlSynegyEffectgridView.vue?vue&type=script&lang=js&"
export * from "./ctrlSynegyEffectgridView.vue?vue&type=script&lang=js&"
import style0 from "./ctrlSynegyEffectgridView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VProgressCircular,VSimpleTable,VTooltip})
